import React from 'react';
import { Box } from '@mui/material';

import { CustomEditorProps, SigmaYAMLEditor, JSONEditor, MarkdownEditor, PlainTextEditor } from './../Editors';

export type UnifiedMitigationType = 1 | 2 | 3 | 4 | 5 | number;

interface UnifiedMitigationContentEditorProps {
  value?: string;
  onChange?: (val: string) => void;
  type: UnifiedMitigationType | null;
  readonly: boolean;
}

const editorRegistry: Record<number, React.FC<CustomEditorProps>> = {
  1: SigmaYAMLEditor,
  2: JSONEditor,
  3: JSONEditor,
  4: MarkdownEditor,
  5: MarkdownEditor
};

export const UnifiedMitigationContentEditor: React.FC<UnifiedMitigationContentEditorProps> = ({
  value,
  onChange,
  type,
  readonly
}) => {
  let Editor: React.FC<CustomEditorProps> | null = null;

  if (type == null) {
    return (
      <Box sx={{ my: 2, color: 'text.secondary', fontStyle: 'italic' }}>
        Please select a mitigation type to begin editing the content.
      </Box>
    );
  }

  Editor = editorRegistry[type] || PlainTextEditor;

  return (
    <Box sx={{ my: 2 }}>
      <Editor value={value} onChange={onChange} readonly={readonly} />
    </Box>
  );
};
